export { default } from './TemplateHtmlView';
